export const changelogEntries = [
  {
    date: "2026-09-16",
    title: "日榜的日期选择器换成 token 热力图",
    tag: "Web",
    source: "CDBEAR-556",
    changes: [
      "日榜模式下，原来的日历输入框换成一整条全年热力图：一列一周、一行一个星期，从左到右横向滑动看完全年，默认停在最新一周；每格一天，颜色从透明到全黑分五档，按当天 token 占日目标（1 亿）的比例走，满 1 亿就是全黑。",
      "点任意一天，榜单直接切到那天；今天带虚线标记，还没到的日子不能点。悬停或选中会显示那天的 token 数，顶部同时给出今年已上传天数和达标天数。",
      "热力图用的是你自己的上传记录，与目标黑板的年度进度同源；年度数据按年缓存，点日期不再重拉一整年，刷新按钮会强制重拉。周、月、季、年模式的时间窗口控件保持不变。",
    ],
  },
  {
    date: "2026-09-16",
    title: "修复登录后榜单整页报错",
    tag: "Web",
    source: "登录榜 500 线上排障",
    changes: [
      "修复登录后日榜、周期榜和总量榜整页报错的问题：页面此前会显示 internal_error，参赛人数、平均 Token 和我的排名全部落回 0 或空白。",
      "故障原因是榜单查询把每一位合资格成员摊成一个独立的数据库查询参数，社区成员涨到 98 位时越过了 D1 单条查询最多 100 个参数的上限；现在成员名单整体作为一个参数传递，成员继续增长也不会再触发。",
      "故障期间上传、个人用量和未登录的公开榜预览一直正常，本次修复不改变榜单口径、排序和参榜资格规则。",
    ],
  },
  {
    date: "2026-07-19",
    title: "排行榜只面向小能熊社区成员",
    tag: "Web",
    source: "CDBEAR-14 / CDBEAR-13 / CDBEAR-46",
    changes: [
      "日榜、周期榜和总量榜只统计小能熊社区成员；尚未产生对应 provider 用量的社区成员以 0 Token、无竞争名次的状态排在正数用户之后。",
      "非社区成员仍可使用 Token Economics、配对 Mac App、上传并查看自己的用量，但不会出现在榜单中，个人排名显示为空。",
      "正数用户继续沿用原有排序和排名语义；参赛人数与平均 Token 仍按已上传正数用户计算，榜单同时展示合资格成员总数与已上传人数。",
      "排行榜 API 增加 limit + offset 分页、合资格人数、活跃人数和活跃 Token 总量；匿名公开榜继续只展示已有正数上传的安全预览字段。",
      "登录后的日榜与总量榜会展示大会员、AI 社群、AI 内参等小能熊社区会员身份，前三名领奖台与完整榜单保持一致。",
      "会员身份和参榜资格由小能熊学习基建自动识别，无需为了排行榜再登录一次；资格服务暂时不可用时榜单会明确暂停，上传与个人用量不受影响。",
      "公共排行榜预览继续不包含会员身份；Token Economics 不保存小鹅通权益规则或会员状态。",
    ],
  },
  {
    date: "2026-07-16",
    title: "会员社区每日 Token 动态接入",
    tag: "Platform",
    source: "candobear-infra token daily feed",
    changes: [
      "新增 Token Economics 到小能熊会员社区的每日用量供给接口，排行榜继续作为 token 用量与成本数据的 Source of Truth，社区动态保存分享发生时的历史快照。",
      "每日状态按北京时间自然日判定；仅达到 ready 分享门槛且 token 大于 0 的日期由社区消费，已发布动态不随后续榜单上传回刷。",
      "成本继续标注为 CodexBar 本地估算、非官方账单；任一实际 provider 成本缺失时不展示美元金额。",
      "接口只提供日汇总与必要观测字段，不包含 prompt、消息、模型明细、Token Economics user id 或上传诊断标识；现有排行榜、上传链与 Mac App 不变。",
    ],
  },
  {
    date: "2026-07-05",
    title: "Worker 架构优化",
    tag: "Platform",
    source: "Token Economics Worker 架构优化 PRD",
    changes: [
      "Worker 入口收敛为顶层分发、旧路径兼容、静态资源 fallback 和共享错误处理，登录、上传、设备配对、排行榜和 Mac release 迁入独立 route module。",
      "上传凭证、每日用量写入、排行榜读取和 usage 序列化拆成独立 storage/domain module，native device pairing 只依赖 native_mac 上传凭证创建能力。",
      "外部 HTTP API、上传 payload 白名单、summary-only 隐私边界、D1 schema、Mac App 下载和 appcast contract 保持不变。",
    ],
  },
  {
    date: "2026-07-05",
    title: "Token 已上传总量榜",
    tag: "Web",
    source: "Token 总量榜 v1",
    changes: [
      "新增已上传总量榜，从服务端已收到的 CodexBar daily summary 聚合总 token，不改变上传 payload。",
      "排行榜首页保留日榜默认入口，新增日榜 / 总量榜切换，provider 继续支持合计、Codex 和 Claude Code。",
      "总量目标黑板增加 30 亿、100 亿、300 亿、1000 亿里程碑，公开预览只展示昵称、头像、总 token、活跃天数和最近日期。",
    ],
  },
  {
    date: "2026-07-03",
    title: "Web V2 排行榜视觉重设计",
    tag: "Web",
    source: "本轮 V2 前端交接 + 生产实机反馈",
    changes: [
      "排行榜首页升级为琥珀顶栏、巨型标题、个人目标黑板、前三名领奖台和更紧凑的桌面/移动榜单。",
      "目标黑板改为个人日目标与年度目标双进度，年度累计复用现有我的上传记录按年汇总。",
      "移动端控件、统计卡顺序、领奖台底座奖牌、Mac App 下载卡和页脚文案按生产实机反馈完成收尾。",
      "设置页重排上传状态、上传 token 和 Mac App 自动上传流程，保留 native-only 上传与 summary-only 隐私说明。",
      "更新日志页改为时间线布局，设备批准页改为独立琥珀授权卡，并继续沿用原有登录、批准和撤销逻辑。",
      "前端移除未使用的 shadcn/Tailwind 依赖，改为 V2 品牌手写 CSS，Worker API、D1 schema 和上传 payload 不变。",
    ],
  },
  {
    date: "2026-07-01",
    title: "Mac App 0.1.6 浏览器 Keychain 弹窗修复",
    tag: "Mac App",
    source: "c3ccca2c",
    changes: [
      "小能熊 agent 经济学发行版默认并强制关闭 OpenAI Web/Codex 浏览器 Cookie 导入，避免后台刷新时逐个浏览器读取 Safe Storage Keychain 并弹出授权密码框。",
      "保留上传 Token 的 Keychain 存储路径，不使用全局禁用 Keychain 的方式规避弹窗。",
      "0.1.6 已完成 Developer ID 签名、公证、staple、Sparkle appcast 和 latest DMG 发布。",
    ],
  },
  {
    date: "2026-06-30",
    title: "Web 排行榜体验整理",
    tag: "Web",
    source: "本轮生产实机反馈",
    changes: [
      "导航栏改为 full width，移除多余的“排行榜”入口，并把右上角退出按钮收敛到头像菜单。",
      "新增设置页入口，将我的上传状态、上传 Token、Mac App 自动上传说明从排行榜页移入设置页。",
      "标题改为“小能熊 Token 排行榜”，说明文案改为社区排名与年度目标表达。",
      "Mac App 下载卡片移动到页面底部，减少首屏排行榜干扰。",
      "数据卡片调整为：我的 token、我的排名、参赛人数、平均 token；平均 token 按当前榜单总 token / 参赛人数计算。",
      "移动端排行榜卡片优化：指标压缩为两行布局，provider 摘要移到 Total Tokens 大数字下方，头像和昵称改为紧挨排名左对齐。",
    ],
  },
  {
    date: "2026-06-30",
    title: "Mac App 0.1.5 安装器修复",
    tag: "Mac App",
    source: "beeda324",
    changes: [
      "Sparkle 自动更新改用 Installer XPC service 安装流程，避免 macOS 授权服务返回 errAuthorizationInternal 后无法启动安装器。",
      "更新发布脚本、打包测试和 release 文档，确保后续自动更新包继续走可验证的安装链路。",
    ],
  },
  {
    date: "2026-06-30",
    title: "Mac App 0.1.4 历史同步补传",
    tag: "Mac App",
    source: "ba89654d",
    changes: [
      "设备配对后自动执行 365 天本地历史 token 用量 backfill。",
      "历史补传完成后继续按 today/yesterday 增量同步，降低首次安装后榜单数据缺口。",
      "补充同步状态存储、测试覆盖和 Mac App 使用文档。",
    ],
  },
  {
    date: "2026-06-29",
    title: "Mac App 0.1.1-0.1.3 自动更新与同步修复",
    tag: "Mac App",
    source: "apps/candobear-token-sync-mac/CHANGELOG.md",
    changes: [
      "自动更新切到小能熊自有 Sparkle feed，并发布 Sparkle ZIP、R2 appcast 和 release manifest 元信息。",
      "自动上传成功后立即刷新菜单栏排行榜，避免 Web 已更新但 Mac App 继续显示旧缓存。",
      "修正 Codex 本地成本估算，避免 cached input 被重复计费；升级后自动重建本地 Codex 成本缓存。",
      "排行榜菜单只读文字改为自绘菜单行，避免被 macOS 当作 disabled menu item 整体置灰。",
    ],
  },
  {
    date: "2026-06-29",
    title: "Native upload 基础能力上线",
    tag: "Platform",
    source: "1eb404b5",
    changes: [
      "新增小能熊 agent 经济学 Mac App 与 native device pairing 流程。",
      "新增 native device sessions 和 native-only uploads 数据迁移，生产上传入口收敛到 Mac App 设备配对 Token。",
      "网页支持设备批准页、Mac App 下载入口和上传说明，上传 payload 继续限制为日汇总字段。",
      "Worker 增加 native device store、上传 token hash 校验、Codex/Claude Code 榜单聚合与测试覆盖。",
    ],
  },
];
